import { ppData } from './ppData.config';
import { compareLayoutsByPrecedence } from '../../../utils/compareLayoutsByPrecedence';
const initialObj = {
    typeValues: [[], -1],
    layoutValues: [[], -1],
    sizeValues: [[], -1],
    depthValues: [[], -1]
};
export const { typeValues, layoutValues, sizeValues, depthValues } = ppData.options.reduce((obj, option, index) => {
    switch (option.name) {
        case 'Type':
            obj.typeValues = [option.values, index];
            break;
        case 'Layout':
            obj.layoutValues = [
                ppData.isOldCustom
                    ? option.values
                    : option.values.sort(({ shape: a }, { shape: b }) => {
                        return compareLayoutsByPrecedence(a, b);
                    }),
                index
            ];
            break;
        case 'Size':
            obj.sizeValues = [option.values, index];
            break;
        case 'Depth':
            obj.depthValues = [option.values, index];
            break;
    }
    return obj;
}, initialObj);
